<template>
  <div class="card mb-3 shadow-sm" style="margin-right: 5px;" :class="{ 'border-primary': isSelected }" @click="toggleSelection">
    <div class="card-body d-flex align-items-center">
      <!-- Checkbox -->
      <input type="checkbox" class="form-check-input me-3" v-model="isSelected" />

      <!-- Card content -->
      <div>
        <h5 class="card-title mb-1 fs-12">Référence : {{ reference }}</h5>
        <p class="card-text text-muted mb-1">Mois : {{  month }} </p>
        <p class="card-text text-muted">Coût : {{ cost }} FCFA</p>
      </div>
    </div>
  </div>
</template>

<script>
import { boolean } from 'yup';

export default {
  name: "SelectableCard",
  props: {
    reference: {
      type: String,
      required: true,
      default: "FA_"
    },
    month: {
      type: String,
      required: true,
      default: "0"
    },
    cost: {
      type: Number,
      required: true,
      default: 0
    },
    etat: {
      type: boolean,
      required: true,
      default: false
    },
  },
  data() {
    return {
      isSelected: false,
    };
  },
  methods: {
    toggleSelection() {
      this.isSelected = !this.isSelected;
      this.$emit("select", this.isSelected); // Émet l'état sélectionné au parent
    },

    getMonth(val) {
      const months = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ];
      return months[val];
    }

  },
};
</script>

<style scoped>
.card {
  cursor: pointer;
  transition: all 0.2s;
}

.card.border-primary {
  background-color: #e7f3ff;
}
</style>